const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const BOOKING_ID_PATTERN = /^[a-zA-Z0-9-]{1,128}$/;
const RESERVATION_TOKEN_PATTERN = /^[a-f0-9]{64}$/i;

export const EMBED_QUERY_KEY = 'embed';
export const CHECKOUT_MESSAGE_TYPE = 'sanookpass:checkout';

export function isEmbeddedMode(search = window.location.search) {
  return new URLSearchParams(search).get(EMBED_QUERY_KEY) === '1';
}

export function buildCheckoutHandoffUrl({ origin, slug, bookingId, reservationToken }) {
  if (!SLUG_PATTERN.test(slug || '')) throw new Error('INVALID_SHOP_SLUG');
  if (!BOOKING_ID_PATTERN.test(String(bookingId || ''))) throw new Error('INVALID_BOOKING_ID');
  if (!RESERVATION_TOKEN_PATTERN.test(reservationToken || '')) {
    throw new Error('INVALID_RESERVATION_TOKEN');
  }

  const url = new URL(`/${slug}`, origin);
  const fragment = new URLSearchParams({
    sp_booking: String(bookingId),
    sp_token: reservationToken,
  });
  url.hash = fragment.toString();
  return url.toString();
}

export function consumeCheckoutHandoff(
  slug,
  { location = window.location, history = window.history } = {}
) {
  if (!SLUG_PATTERN.test(slug || '')) return null;
  const hash = String(location.hash || '').replace(/^#/, '');
  if (!hash) return null;

  const params = new URLSearchParams(hash);
  const bookingId = params.get('sp_booking') || '';
  const reservationToken = params.get('sp_token') || '';
  if (
    !BOOKING_ID_PATTERN.test(bookingId) ||
    !RESERVATION_TOKEN_PATTERN.test(reservationToken)
  ) {
    return null;
  }

  // Remove the recovery capability from the address bar before doing any
  // network work. The token remains only in memory and local storage.
  history.replaceState({}, '', `${location.pathname}${location.search || ''}`);
  return {
    id: bookingId,
    bookingId,
    reservationToken,
    status: 'pending',
    paymentStatus: 'requires_payment',
  };
}
